"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlmeApiBase = void 0;
const AuthTokenHandlerBase_1 = require("../Authorization/AuthTokenHandlerBase");
const RequestInitHandler_1 = require("../RequestInitHandler");
class AlmeApiBase extends AuthTokenHandlerBase_1.AuthTokenHandlerBase {
    constructor(logger, httpHandler, settings) {
        super(logger, httpHandler, settings);
        this.Logger = logger;
        this.HttpHandler = httpHandler;
        this.Settings = settings;
        this.AlmeBaseUri =
            `${this.Settings.AlmeApiProtocol}${this.Settings.AlmeApiHostname}${this.Settings.AlmeApiBasePath}`;
    }
    SendInputAsync(converseRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const converseRequestInfo = `${this.AlmeBaseUri}${this.Settings.AlmeApiConverseEndpoint}`;
            const converseRequestInit = new RequestInitHandler_1.default(this.Logger, this.Settings, 'POST', JSON.stringify(converseRequest));
            this.AddAuthHeader(converseRequestInit);
            const response = yield this.HttpHandler.SendAsync(converseRequestInfo, converseRequestInit);
            if (typeof response !== 'object') {
                throw new Error('Invalid Response');
            }
            return response;
        });
    }
    SendAppEventAsync(appEventRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const appEventRequestInfo = `${this.AlmeBaseUri}${this.Settings.AlmeApiAppEventEndpoint}`;
            const appEventRequestInit = new RequestInitHandler_1.default(this.Logger, this.Settings, 'POST', JSON.stringify(appEventRequest));
            this.AddAuthHeader(appEventRequestInit);
            const response = yield this.HttpHandler.SendAsync(appEventRequestInfo, appEventRequestInit);
            if (typeof response !== 'object') {
                throw new Error('Invalid Response');
            }
            return response;
        });
    }
    SendRequestUnitAsync(requestUnitRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestUnitRequestInfo = `${this.AlmeBaseUri}${this.Settings.AlmeApiRequestUnitEndpoint}`;
            const requestUnitRequestInit = new RequestInitHandler_1.default(this.Logger, this.Settings, 'POST', JSON.stringify(requestUnitRequest));
            this.AddAuthHeader(requestUnitRequestInit);
            const response = yield this.HttpHandler.SendAsync(requestUnitRequestInfo, requestUnitRequestInit);
            if (typeof response !== 'object') {
                throw new Error('Invalid Response');
            }
            return response;
        });
    }
    SendReportingEventAsync(reportingEventRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const reportingEventRequestInfo = `${this.AlmeBaseUri}${this.Settings.AlmeApiReportingEventEndpoint}`;
            const reportingEventRequestInit = new RequestInitHandler_1.default(this.Logger, this.Settings, 'POST', JSON.stringify(reportingEventRequest));
            this.AddAuthHeader(reportingEventRequestInit);
            yield this.HttpHandler.SendAsync(reportingEventRequestInfo, reportingEventRequestInit);
            return true;
        });
    }
    GetConfigurationAsync(configRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const configRequestInfo = `${this.AlmeBaseUri}${this.Settings.AlmeApiConfigurationEndpoint}`;
            const configRequestInit = new RequestInitHandler_1.default(this.Logger, this.Settings, 'POST', JSON.stringify(configRequest));
            this.AddAuthHeader(configRequestInit);
            const response = yield this.HttpHandler.SendAsync(configRequestInfo, configRequestInit);
            if (typeof response !== 'object') {
                throw new Error('Invalid Response');
            }
            return response;
        });
    }
    GetHistoryAsync(historyRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const historyRequestInfo = `${this.AlmeBaseUri}${this.Settings.AlmeApiGetHistoryEndpoint}`;
            const historyRequestInit = new RequestInitHandler_1.default(this.Logger, this.Settings, 'POST', JSON.stringify(historyRequest));
            this.AddAuthHeader(historyRequestInit);
            const response = yield this.HttpHandler.SendAsync(historyRequestInfo, historyRequestInit);
            if (!Array.isArray(response)) {
                throw new Error('Invalid Response');
            }
            return response;
        });
    }
}
exports.AlmeApiBase = AlmeApiBase;
//# sourceMappingURL=AlmeApiBase.js.map


// WEBPACK FOOTER //
// ../../Alme/AlmeApiBase.ts